module.exports = __webpack_public_path__ + "static/footer_logo-5988469d875959ed7ac926bb37a97635.svg";